import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEvolucionPrecios = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'evolucion_precio',
        name: 'Evolucion Precio',
        component: ViewEvolucionPrecios,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
